// extracted by mini-css-extract-plugin
export var organized = "style-module--organized--446aa";
export var organized__block = "style-module--organized__block--0bdf4";
export var organized__blockItem = "style-module--organized__block-item--f6189";
export var organized__title = "style-module--organized__title--a99a2";
export var whom = "style-module--whom--3391a";
export var whom__block = "style-module--whom__block--eea4c";
export var whom__img = "style-module--whom__img--52b4b";
export var whom__imgVideo = "style-module--whom__img-video--c88b8";
export var whom__point = "style-module--whom__point--cce56";
export var whom__points = "style-module--whom__points--046a1";
export var whom__quote = "style-module--whom__quote--ecb27";